import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact';
import { useEffect, useRef } from 'preact/hooks';
import Filters from './Filters';
import CategorySubmenu from './CategorySubmenu';
import SelectedFilters from './SelectedFilters'

export default ({ isCategorySelected = false, handleOnClickContactSeller }) => {
    const filtersRef = useRef(null);
    const { response: { products },
        query: { query }
    } = useAppState();

    const shouldShowNewSearch = window.cj.nosto.newSearchFeatureEnabled

    useEffect(() => {
        // listener by hooking into cratejoy `window.app` functionality
        app.event('modal-close').subscribe((e) => {
            if (!filtersRef.current) return;
            filtersRef.current.classList.remove('active');
            filtersRef.current.classList.add('inactive');
        });
    }, []);

    const handleFiltersClose = (e) => {
        e.preventDefault();
        app?.modal?.close();
    };

    const RenderHeader = () => {
        if (shouldShowNewSearch && !isCategorySelected)
            return <h4 class='search-result-total'>{products.total} Results for “{query}”</h4>
        else if (isCategorySelected) return ''
        else return (<header>
            <h4>Shopping filters</h4>
            <a href="#" class="app--filters-close" onClick={handleFiltersClose}>
                <i class="plp-icon plp-icon--close"></i>
            </a>
        </header>)
    }

    return (
        <div id={shouldShowNewSearch ? '' : "app--filters"} class="inactive" ref={filtersRef}>

            <RenderHeader />
            <div class={shouldShowNewSearch ? '' : "app--filters-body"}>
                {!shouldShowNewSearch &&
                    <>
                        <CategorySubmenu />
                        <SelectedFilters inSidebar />
                    </>
                }
                <Filters handleOnClickContactSeller={handleOnClickContactSeller} />
            </div>
        </div>
    );
}
